import { useCallback, useContext } from 'react';
import { GrippContext } from '../grippContext';
import { SyncLockedError } from './outboxService';

/**
 * Dispatch-time check for the direct-mutation hooks: throws `SyncLockedError`
 * when an unresolved outbox submission still touches one of the records. It
 * reads the store afresh, so a screen opened before the submission existed
 * cannot slip a write through. Where no outbox is injected (web) it never throws.
 */
export const useEnsureUnlocked = () => {
  const outbox = useContext(GrippContext)?.outbox;
  return useCallback(
    async (...entityIds: Array<string | null | undefined>): Promise<void> => {
      const ids = entityIds.filter((id): id is string => !!id);
      if (!outbox || ids.length === 0) return;
      if (await outbox.isLocked(ids)) throw new SyncLockedError();
    },
    [outbox]
  );
};
